import { call, put, select, takeEvery } from 'redux-saga/effects';
import { GET_RESULT_CONTENT, UPDATE_VERIFICATION } from './actionTypes';
import { SweepContentData, SweepResultContentData } from '../../../../../services/Rocky';
import { updateResultExists, updateResultInfo } from '../action';

function* getResultContent(action) {
  const { id, ddrType } = action;
  try {
    const resultInfo = yield call(SweepContentData.getDataPromise, id, true)
    SweepResultContentData.clean()
    if (resultInfo) {
      let selectVerificationId = '';
      const successList = SweepContentData.getSuccessExpList(id);

      if (successList && successList.length) {
        selectVerificationId = successList[0].verificationId
      } else {
        selectVerificationId = resultInfo.baseVerificationId
      }

      if (selectVerificationId) {
        yield call(SweepResultContentData.getResultExpDataPromise, selectVerificationId, id, true)

        const ssnList = SweepResultContentData.getSignalGroupList(id)
        const _runList = ssnList.map(item => {
          return {
            name: item.name,
            id: item.id,
            displayName: item.name,
          }
        })
        const verificationId = ssnList[0].id
        yield put(updateResultExists(_runList))
        yield put(updateResultInfo({
          name: resultInfo.sweepName,
          channelName: resultInfo.sweepName,
          ddrType: ddrType,
          channelId: id,
          selectList: selectVerificationId ? [selectVerificationId] : [],
          verificationId: verificationId,
          verificationName: ssnList[0].name
        }));
        return
      }
    }
    yield put(updateResultExists([]))
    yield put(updateResultInfo({
      verificationId: "",
      channelId: id,
      verificationName: ""
    }));
  } catch (error) {
    console.error(error)
  }
}

function* updateVerification(action) {
  const { id } = action;
  let { RockyReducer: { result: { resultInfo: { channelId } } } } = yield select();
  const info = SweepResultContentData.getSignalGroupContent(channelId, id)
  if (info && info.id) {
    yield put(updateResultInfo(null, { verificationId: id, verificationName: info.name }));
  }
}

function* rockySSNResultSaga() {
  yield takeEvery(GET_RESULT_CONTENT, getResultContent);
  yield takeEvery(UPDATE_VERIFICATION, updateVerification);
}
export default rockySSNResultSaga;
